/** Supervisor ticket detail URL without app chrome (sidebar / topbar). */
export function isSupervisorTicketChromelessPath(pathname: string): boolean {
  return /^\/supervisor\/tickets\/[^/]+\/?$/.test(pathname);
}

/**
 * Opens `/supervisor/tickets/...` in a separate popup window (not a tab) when the browser allows.
 * Call only from a direct user gesture (click); popup blockers may still block.
 */
export function openSupervisorTicketPopupWindow(pathWithQuery: string): Window | null {
  const path = pathWithQuery.startsWith("/") ? pathWithQuery : `/${pathWithQuery}`;
  const url = `${window.location.origin}${path}`;
  const match = path.match(/^\/supervisor\/tickets\/([^/?#]+)/);
  const ticketKey = match?.[1] ? encodeURIComponent(match[1]) : "ticket";

  const width = Math.min(1280, Math.floor(window.screen.availWidth * 0.92));
  const height = Math.min(920, Math.floor(window.screen.availHeight * 0.9));
  const left = Math.max(
    0,
    window.screenX + Math.floor((window.outerWidth - width) / 2)
  );
  const top = Math.max(
    0,
    window.screenY + Math.floor((window.outerHeight - height) / 2)
  );

  const features = [
    "popup=yes",
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    "menubar=no",
    "toolbar=no",
    "scrollbars=yes",
    "resizable=yes",
  ].join(",");

  return window.open(url, `theo_supervisor_ticket_${ticketKey}`, features);
}
